import * as types from "./actionTypes";
import axios from "axios";
import { accessTokenHeadersObject } from "../../utils/headers";
import { privateAxiosInstance } from "../../utils/axiosInstance";
import { environmentDetails } from "../../environment/environment";

const jobOpeningUrl=environmentDetails.jobOpeningUrl;
const payload = {
  skills: "",
};

//console.log("URL:", jobOpeningUrl);
//console.log("Payload:", payload);

const getJDFromATS = (payload) => (dispatch) => {
  dispatch({ type: types.GET_JD_FROM_ATS_REQUEST });

  return privateAxiosInstance
    .post(jobOpeningUrl, payload, {
      headers: {
        ...accessTokenHeadersObject(),
      }
    })
    .then((res) => {
      return dispatch({
        type: types.GET_JD_FROM_ATS_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log("ATS ERROR:", err);

      return dispatch({
        type: types.GET_JD_FROM_ATS_FAILURE,
        payload: err,
      });
    });
};


export {getJDFromATS};